export const StyleError = {
    backgroundColor: '#1C1E2580', // Красный фон
    color: '#616A8B', // Белый текст
    fontSize: '18px', // Увеличенный шрифт
    padding: '15px', // Увеличенные отступы
    borderRadius: '8px',
    padding:'12px',
    backdropFilter:'blur(10px)'
}